<template>
  <div class="maxBox">
    <div class="findjob_banner banner"></div>
    <div>
      <!-- 循环生成 -->
      <div class="publicJob" v-for="item in requestItem">
        <div class="moneyname">
          <div class="gangwei">
            <div class="name">{{ item.name }}</div>
            <!-- 为空的时候显示'---' -->
            <div class="spanquan">
              <span class="moneyspan1">{{ item.payment || "--" }}</span
              ><span class="spanline"></span>{{ item.location || "--"
              }}<span class="spanline"></span>{{ item.work || "--"
              }}<span class="spanline"></span>{{ item.num }}人<span
                class="spanline"
              ></span
              >{{ item.education }}
            </div>
          </div>
          <div class="updatetime">更新时间：{{ item.update_time }}</div>
        </div>
        <div class="threelabel">
          <div v-for="(r, index) in item.remark.split(',')" :key="index">
            {{ r }}
          </div>
        </div>
        <div class="job_detail">
          <div class="jobHead">职位描述:</div>
          <div class="jobcont" v-html="item.describe"></div>
        </div>
        <div class="job_detail">
          <div class="jobHead">职位要求:</div>
          <div class="jobcont" v-html="item.demand"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FindJob",
  data() {
    return {
     
      JobList: [{}],
      jobdata: [],
      requestItem: "",
    };
  },
  methods: {
    getRequest() {
      this.$axios({
        method: "get",
        url:
          "Data?uid=39&layer=advertiseinfo&operation=query&start=1&count=10&orderfields=update_time%2520desc&queryfields=state&queryvalues=" +
          encodeURIComponent(encodeURIComponent("在线")),
      }).then((res) => {
        this.requestItem = res.data.data;
      });
    },
  },

  created() {
    this.getRequest();
  },
};
</script>

<style scoped>
.updatetime {
  letter-spacing: 2px;
}
.gangwei {
  display: flex;
  align-items: center;
  white-space: nowrap;
  flex-wrap: nowrap;
}
.publicJob {
  width: 1200px;
  margin: 0 auto;
  margin-top: 35px;
  margin-bottom: 25px;
  padding-bottom: 25px;
  border-bottom: 1px solid #aaa;
}
.moneyname {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 25px;
}
.moneyname .name {
  font-size: 30px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  margin-right: 53px;
}
.moneyname .moneyspan1 {
  color: #047ac6;
}

.spanquan {
  display: flex;
  align-items: center;
  height: 23px;
}
.spanline {
  padding-top: 5px;
  display: inline-block;
  margin: 0px 15px;
  width: 2px;
  height: 14px;
  background: #d4d4d4;
}
.threelabel {
  display: flex;
  align-items: center;
  margin-bottom: 5px;
}
.threelabel div {
  padding: 0 10px;
  height: 32px;
  line-height: 32px;
  background: #edf3fb;
  border-radius: 4px;
  margin-right: 20px;
}
.job_detail {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.job_detail .jobHead {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
  line-height: 24px;
  margin-top: 25px;
}
.job_detail p {
  font-size: 14px;
  color: #333;
}
.findjob_banner {
  background: url("../image/banner_zhaopin.jpg") no-repeat center center;
}
.new-infor {
  width: 100%;
  background: #f5f7fa;
}
.jobcont {
  font-size: 14px;
  text-align: left;
  white-space: pre-wrap;
  line-height: 28px;
}
</style>
